import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-6"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "w-full space-y-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "h-10" }, null, -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CargoTypeSection = _resolveComponent("CargoTypeSection")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _component_CargoTableSttSection = _resolveComponent("CargoTableSttSection")!
  const _component_PlaneSchedule = _resolveComponent("PlaneSchedule")!
  const _component_ModalCargoType = _resolveComponent("ModalCargoType")!
  const _component_PopupDetailKoli = _resolveComponent("PopupDetailKoli")!
  const _component_ConfigFeatureFlight = _resolveComponent("ConfigFeatureFlight")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.showPlaneSchedule && !_ctx.isPlaneAutoFlow)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.isRTC || _ctx.selectedCargoTypeV2BookingManual)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode(_component_CargoTypeSection, {
                  showChangeCargo: _ctx.isRTCEdit,
                  onChangeCargo: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setModalCargoType(true)))
                }, null, 8, ["showChangeCargo"]),
                (!_ctx.selectedCargoTypeV2BookingManual)
                  ? (_openBlock(), _createBlock("hr", _hoisted_2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_FormSection, {
              onDataChange: _ctx.initPlaneAuto,
              onLeavePage: _ctx.onLeavePage
            }, null, 8, ["onDataChange", "onLeavePage"])
          ]),
          _createVNode(_component_CargoTableSttSection),
          _hoisted_4
        ], 64))
      : (_ctx.showPlaneSchedule)
        ? (_openBlock(), _createBlock(_component_PlaneSchedule, {
            key: 1,
            onChangeAirport: _ctx.onResetChangeTransitAirport,
            width: "w-11/12"
          }, null, 8, ["onChangeAirport"]))
        : _createCommentVNode("", true),
    (_ctx.showModalCargoType)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_ModalCargoType)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPopupDimensionPieces)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_PopupDetailKoli, { formDetailPieces: _ctx.formDetailPieces }, null, 8, ["formDetailPieces"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      _createVNode(_component_ConfigFeatureFlight, { key: _ctx.showSelectAirport })
    ])
  ], 64))
}